import * as React from "react";
import { forwardRef } from "react";
const SvgCross = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.1969 7.79883L7.79688 16.1988M16.1969 16.1988L7.79688 7.79883L16.1969 16.1988Z", stroke: "#C5C9CB", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
